/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Page_ToggleInputs */

const en_community_page_toggle = /** @type {(inputs: Community_Page_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable Community Page`)
};

const id_community_page_toggle = /** @type {(inputs: Community_Page_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktifkan Halaman Komunitas`)
};

/** @type {(inputs: Community_Page_ToggleInputs) => LocalizedString} */
const es_community_page_toggle = en_community_page_toggle;

/** @type {(inputs: Community_Page_ToggleInputs) => LocalizedString} */
const fr_community_page_toggle = en_community_page_toggle;

/** @type {(inputs: Community_Page_ToggleInputs) => LocalizedString} */
const de_community_page_toggle = en_community_page_toggle;

/** @type {(inputs: Community_Page_ToggleInputs) => LocalizedString} */
const ja_community_page_toggle = en_community_page_toggle;

/** @type {(inputs: Community_Page_ToggleInputs) => LocalizedString} */
const zh_community_page_toggle = en_community_page_toggle;

/** @type {(inputs: Community_Page_ToggleInputs) => LocalizedString} */
const ar_community_page_toggle = en_community_page_toggle;

/** @type {(inputs: Community_Page_ToggleInputs) => LocalizedString} */
const it_community_page_toggle = en_community_page_toggle;

/** @type {(inputs: Community_Page_ToggleInputs) => LocalizedString} */
const ru_community_page_toggle = en_community_page_toggle;

/** @type {(inputs: Community_Page_ToggleInputs) => LocalizedString} */
const pt_community_page_toggle = en_community_page_toggle;

/** @type {(inputs: Community_Page_ToggleInputs) => LocalizedString} */
const ko_community_page_toggle = en_community_page_toggle;

/**
* | output |
* | --- |
* | "Enable Community Page" |
*
* @param {Community_Page_ToggleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_page_toggle = /** @type {((inputs?: Community_Page_ToggleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Page_ToggleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_page_toggle(inputs)
	if (locale === "es") return es_community_page_toggle(inputs)
	if (locale === "fr") return fr_community_page_toggle(inputs)
	if (locale === "de") return de_community_page_toggle(inputs)
	if (locale === "ja") return ja_community_page_toggle(inputs)
	if (locale === "zh") return zh_community_page_toggle(inputs)
	if (locale === "ar") return ar_community_page_toggle(inputs)
	if (locale === "id") return id_community_page_toggle(inputs)
	if (locale === "it") return it_community_page_toggle(inputs)
	if (locale === "ru") return ru_community_page_toggle(inputs)
	if (locale === "pt") return pt_community_page_toggle(inputs)
	return ko_community_page_toggle(inputs)
});